import _Fab from "@mui/material/Fab";
import _Tooltip from "@mui/material/Tooltip";
import { ThemeProvider, alpha } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { styled } from 'styled-components';
import pegman from '../../assets/images/pegman.png';
const id = 'pegman-control';
const tooltipId = 'pegman-control-button-tooltip';
const buttonId = 'pegman-control-button';
const pegmanEleId = 'pegman';
let root;
export class MapillaryControl {
  prevX = null;
  onAdd(_map) {
    this.map = _map;
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl';
    const content = document.createElement('div');
    content.id = id;
    this.container.appendChild(content);
    return this.container;
  }
  addGrabbingClass(_element) {
    const element = typeof _element === 'string' ? document.getElementById(_element) : _element;
    if (element) element.classList.add('grabbing');
  }
  removeGrabbingClass(_element) {
    const element = typeof _element === 'string' ? document.getElementById(_element) : _element;
    if (element) element.classList.remove('grabbing', 'grabbing-left', 'grabbing-right');
  }
  handleDrag = ({
    clientX,
    clientY
  }) => {
    const buttonElement = document.getElementById(buttonId);
    const pegman = document.getElementById(pegmanEleId);
    if (buttonElement && pegman) {
      const {
        x,
        y
      } = buttonElement.getBoundingClientRect();
      if (this.prevX === null) {
        buttonElement.classList.add('grabbing-left');
      } else if (this.prevX < clientX) {
        buttonElement.classList.remove('grabbing-left');
        buttonElement.classList.add('grabbing-right');
      } else if (this.prevX > clientX) {
        buttonElement.classList.remove('grabbing-right');
        buttonElement.classList.add('grabbing-left');
      }
      pegman.style.transform = `translate(${clientX - x - 20}px, ${clientY - y - 40}px)`;
      this.prevX = clientX;
    }
  };
  handleDragEnd = () => {
    this.callbacks?.onDragEnd();
    if (this.map) this.removeGrabbingClass(this.map.getContainer().getElementsByTagName('canvas')[0]);
    this.removeGrabbingClass(buttonId);
    const element = document.getElementById(pegmanEleId);
    if (element) {
      element.style.transform = `translate(0, 0)`;
    }
    this.prevX = null;
    window.removeEventListener('mousemove', this.handleDrag);
    window.removeEventListener('mouseup', this.handleDragEnd);
  };
  handleDragStart = ({
    button
  }) => {
    if (button !== 0) return;
    this.callbacks?.onDragStart();
    if (this.map) this.addGrabbingClass(this.map.getContainer().getElementsByTagName('canvas')[0]);
    this.addGrabbingClass(buttonId);
    const element = document.getElementById(tooltipId);
    if (element) element.style.display = 'none';
    window.addEventListener('mousemove', this.handleDrag);
    window.addEventListener('mouseup', this.handleDragEnd);
  };
  init(theme, titles, callbacks) {
    this.theme = theme;
    this.titles = titles;
    this.callbacks = callbacks;
    this.update(false);
  }
  update(locked) {
    if (!this.map || !this.theme) return;
    let cmp = 0;
    const ele = document.getElementById(id);
    if (!ele) return;
    root = root || createRoot(ele);
    if (this.map.getZoom() < 14) {
      root.render(/*#__PURE__*/React.createElement(ThemeProvider, {
        theme: this.theme
      }, /*#__PURE__*/React.createElement(_Tooltip, {
        id: tooltipId,
        placement: "left",
        title: this.titles?.tooFar || ''
      }, /*#__PURE__*/React.createElement(StyledFab, {
        disableRipple: true,
        className: "too-far",
        id: buttonId,
        size: "small"
      }, /*#__PURE__*/React.createElement(StyledPegman, {
        id: pegmanEleId
      })))));
    } else {
      root.render(/*#__PURE__*/React.createElement(ThemeProvider, {
        theme: this.theme
      }, locked ? /*#__PURE__*/React.createElement(_Tooltip, {
        id: tooltipId,
        placement: "left",
        title: this.titles?.locked || ''
      }, /*#__PURE__*/React.createElement(StyledFab, {
        className: "locked",
        onClick: () => {
          if (cmp > 0) this.callbacks?.onClear();
          ++cmp;
        },
        size: "small"
      }, /*#__PURE__*/React.createElement(StyledPegman, {
        id: pegmanEleId
      }))) : /*#__PURE__*/React.createElement(_Tooltip, {
        id: tooltipId,
        placement: "left",
        title: this.titles?.unlocked || ''
      }, /*#__PURE__*/React.createElement(StyledFab, {
        id: buttonId,
        onMouseDown: this.handleDragStart,
        size: "small"
      }, /*#__PURE__*/React.createElement(StyledPegman, {
        id: pegmanEleId
      })))));
    }
  }
  lock() {
    this.update(true);
  }
  unlock() {
    this.update(false);
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
const StyledFab = styled(_Fab)`
  && {
    background-color: #fff;
    cursor: grab;

    &:not(:disabled):hover {
      background-color: #d5d5d5;
    }

    &:not(.too-far):not(.locked):hover {
      #pegman::before {
        background-position: -48px 0;
      }
    }

    &.too-far {
      background-color: #d5d5d5;
      cursor: default;

      &:hover {
        background-color: #d5d5d5;
      }

      &:active {
        box-shadow:
          0 3px 5px -1px rgb(0 0 0 / 20%),
          0 6px 10px 0 rgb(0 0 0 / 14%),
          0 1px 18px 0 rgb(0 0 0 / 12%);
      }
    }

    &.grabbing {
      cursor: grabbing;

      &::before {
        background-image: ${`url(${pegman})`};
        background-position: -24px 0;
        background-repeat: no-repeat;
        background-size: auto 24px;
        content: ' ';
        display: block;
        height: 24px;
        left: 8px;
        position: absolute;
        top: 8px;
        width: 24px;
      }

      #pegman::before {
        background-position: -72px 0;
      }

      &.grabbing-right {
        #pegman::before {
          background-position: -96px 0;
        }
      }

      #pegman::after {
        opacity: 1;
      }
    }

    &.locked {
      cursor: pointer;

      #pegman::before {
        background-position: -24px 0;
      }
    }

    .MuiFab-label {
      height: 100%;
    }
  }
`;
const StyledPegman = styled.div`
  height: 40px;
  position: relative;
  width: 40px;

  &::before {
    background-image: ${`url(${pegman})`};
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: auto 24px;
    content: ' ';
    display: block;
    height: 24px;
    left: 8px;
    position: absolute;
    top: 8px;
    width: 24px;
  }

  &::after {
    display: block;
    border: 2px solid white;
    background-color: ${alpha('#659F4A', 0.8)};
    border-radius: 50%;
    box-shadow: 3px 10px 25px rgb(105 185 70 / 90%);
    content: ' ';
    height: 6px;
    left: 16px;
    opacity: 0;
    overflow: visible;
    position: absolute;
    top: 36px;
    visibility: visible;
    width: 6px;
  }
`;